import LogoTagaNow from "@/assets/images/taganow-logo-color.svg";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { init, send } from "@emailjs/browser";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  // Initialize EmailJS
  useEffect(() => {
    init("ukDAB30vdZEv1JIaL");
  }, []);

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      setMessage("Vui lòng nhập email hợp lệ");
      return;
    }
    setIsSubmitting(true);
    setMessage("");

    try {
      const result = await send("service_kvrv2ug", "template_rf9jol4", {
        to_email: "toannadi@gmail.com",
        user_email: email,
        subject: "Đăng ký newsletter mới từ TagaNow",
        message: `Có người dùng mới đăng ký newsletter với email: ${email}`,
        timestamp: new Date().toLocaleString("vi-VN"),
      });

      if (result.status === 200) {
        setMessage("Đăng ký thành công! Cảm ơn bạn đã quan tâm.");
        setEmail("");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setMessage("Có lỗi xảy ra. Vui lòng thử lại sau.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (message) setMessage(""); // Clear message when user types
  };

  return (
    <footer className="relative bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 border-t border-slate-200/50 dark:border-gray-700/50">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5 dark:opacity-10"></div>

      <div className="relative max-w-7xl mx-auto px-4 py-16 lg:py-20">
        {/* Main Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* About Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white relative">
              Về chúng tôi
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
            </h3>
            <nav className="space-y-4">
              {[
                { label: "Giới thiệu", href: "#*" },
                { label: "Đối tác", href: "#*" },
                { label: "Công việc", href: "#*" },
                { label: "Tin tức", href: "#*" },
              ].map((item, index) => (
                <div key={index}>
                  <a
                    href={item.href}
                    className="group flex items-center text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-300 ease-out text-sm font-medium"
                    tabIndex={0}
                    aria-label={item.label}
                  >
                    <span className="relative">
                      {item.label}
                      <span className="absolute inset-x-0 bottom-0 h-0.5 bg-blue-600 dark:bg-blue-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </span>
                  </a>
                </div>
              ))}
            </nav>
          </div>

          {/* Support Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white relative">
              Hỗ trợ
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full"></div>
            </h3>
            <nav className="space-y-4">
              {[
                { label: "Discord", href: "#*" },
                { label: "Twitter", href: "#*" },
                { label: "Facebook", href: "#*" },
                { label: "Liên hệ", href: "#*" },
              ].map((item, index) => (
                <div key={index}>
                  <a
                    href={item.href}
                    className="group flex items-center text-gray-600 dark:text-gray-300 hover:text-green-600 dark:hover:text-green-400 transition-all duration-300 ease-out text-sm font-medium"
                    tabIndex={0}
                    aria-label={item.label}
                  >
                    <span className="relative">
                      {item.label}
                      <span className="absolute inset-x-0 bottom-0 h-0.5 bg-green-600 dark:bg-green-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </span>
                  </a>
                </div>
              ))}
            </nav>
          </div>

          {/* Terms Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white relative">
              Điều khoản
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full"></div>
            </h3>
            <nav className="space-y-4">
              {[
                { label: "Chính sách bảo mật", href: "#*" },
                { label: "Cấp phép", href: "#*" },
                { label: "Điều khoản", href: "#*" },
              ].map((item, index) => (
                <div key={index}>
                  <a
                    href={item.href}
                    className="group flex items-center text-gray-600 dark:text-gray-300 hover:text-purple-600 dark:hover:text-purple-400 transition-all duration-300 ease-out text-sm font-medium"
                    tabIndex={0}
                    aria-label={item.label}
                  >
                    <span className="relative">
                      {item.label}
                      <span className="absolute inset-x-0 bottom-0 h-0.5 bg-purple-600 dark:bg-purple-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </span>
                  </a>
                </div>
              ))}
            </nav>
          </div>

          {/* Download Section */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-gray-900 dark:text-white relative">
              Tải về
              <div className="absolute -bottom-2 left-0 w-12 h-1 bg-gradient-to-r from-orange-500 to-red-500 rounded-full"></div>
            </h3>
            <nav className="space-y-4">
              {[
                { label: "iOS", href: "#*" },
                { label: "Android", href: "#*" },
                { label: "Windows", href: "#*" },
                { label: "MacOS", href: "#*" },
              ].map((item, index) => (
                <div key={index}>
                  <a
                    href={item.href}
                    className="group flex items-center text-gray-600 dark:text-gray-300 hover:text-orange-600 dark:hover:text-orange-400 transition-all duration-300 ease-out text-sm font-medium"
                    tabIndex={0}
                    aria-label={item.label}
                  >
                    <span className="relative">
                      {item.label}
                      <span className="absolute inset-x-0 bottom-0 h-0.5 bg-orange-600 dark:bg-orange-400 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></span>
                    </span>
                  </a>
                </div>
              ))}
            </nav>
          </div>
        </div>

        {/* Divider with gradient */}
        <div className="my-16">
          <div className="h-px bg-gradient-to-r from-transparent via-slate-300 dark:via-gray-600 to-transparent"></div>
        </div>

        {/* Bottom Section */}
        <div className="space-y-8">
          {/* Logo and Brand */}
          <div className="flex flex-col items-center space-y-6">
            <a
              href="#*"
              className="group flex items-center space-x-3 transition-transform duration-300 hover:scale-105"
              tabIndex={0}
              aria-label="Taganow Logo"
            >
              <div className="relative">
                <img
                  src={LogoTagaNow}
                  className="h-10 sm:h-12 transition-all duration-300 group-hover:brightness-110"
                  alt="Taganow Logo"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-lg scale-0 group-hover:scale-110 transition-transform duration-300"></div>
              </div>
            </a>

            {/* Newsletter Subscription */}
            <form
              onSubmit={handleEmailSubmit}
              id="newsletter-form"
              className="flex flex-col sm:flex-row items-center gap-4 p-6 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-2xl border border-slate-200/50 dark:border-gray-700/50"
            >
              <div className="text-center sm:text-left">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  Đăng ký nhận tin tức mới nhất
                </p>
                <p className="text-xs text-gray-600 dark:text-gray-400">
                  Cập nhật những tính năng và ưu đãi mới
                </p>
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex gap-3">
                  <input
                    type="email"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Email của bạn"
                    className="px-4 py-2 text-sm bg-white dark:bg-gray-700 border border-slate-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all duration-300"
                    required
                    disabled={isSubmitting}
                  />
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="px-6 py-2 text-white text-sm font-medium rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {isSubmitting ? "Đang gửi..." : "Đăng ký"}
                  </Button>
                </div>
                {message && (
                  <p
                    className={`text-xs text-center ${
                      message.includes("thành công")
                        ? "text-green-600 dark:text-green-400"
                        : "text-red-600 dark:text-red-400"
                    }`}
                  >
                    {message}
                  </p>
                )}
              </div>
            </form>
          </div>

          {/* Copyright */}
          <div className="text-center space-y-2">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              ©2024{" "}
              <span className="font-semibold bg-gradient-to-r  from-cyan-500 via-teal-500 via-blue-500 via-indigo-500 to-purple-600 bg-clip-text text-transparent">
                TagaNow™
              </span>
              . All Rights Reserved.
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500">
              Được phát triển với ❤️ tại TagaStudio
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
